<template>
  <van-field
    v-model="displayText"
    :label="label"
    :required="required"
    readonly
    :disabled="disabled"
    autosize
    placeholder="请选择"
    is-link
    @click="handleClick"
  />
  <van-popup v-model:show="showPicker" position="bottom" :on-click-overlay="onCancel">
    <van-picker
      :columns="columns"
      item-height="56px"
      :readonly="disabled || readonly"
      @cancel="showPicker = false"
      @confirm="onConfirm"
    >
      <template #option="option">
        <div :style="`width: 100%`">
          <van-checkbox-group v-model="internalValue" :style="`display: inline-block;  margin-left: 250px`">
            <van-checkbox :name="option.value" shape="square">{{ option.text }}</van-checkbox>
          </van-checkbox-group>
        </div>
      </template>
    </van-picker>
  </van-popup>
</template>
<script>
import { ref, watch, computed } from 'vue';
import { Field, Popup, Picker, Checkbox, CheckboxGroup } from 'vant';

export default {
  name: 'MultiSelectPicker',
  components: {
    'van-field': Field,
    'van-popup': Popup,
    'van-picker': Picker,
    'van-checkbox': Checkbox,
    'van-checkbox-group': CheckboxGroup,
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '选择项',
    },
    title: {
      type: String,
      default: '请选择',
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const showPicker = ref(false);
    const internalValue = ref([...(props.modelValue ?? [])]);

    const displayText = computed(() => {
      return props.columns
        .filter((option) => props.modelValue?.includes(option.value))
        .map((option) => option.text)
        .join(', ');
    });

    watch(
      () => props.modelValue,
      (newValue) => {
        internalValue.value = [...(newValue ?? [])];
      },
    );

    const handleClick = () => {
      if (!props.readonly && !props.disabled) showPicker.value = true;
      internalValue.value = [...(props.modelValue ?? [])];
    };
    const onConfirm = () => {
      emit('update:modelValue', [...(internalValue.value ?? [])]);
      showPicker.value = false;
    };

    const onCancel = () => {
      showPicker.value = false;
    };

    return {
      showPicker,
      internalValue,
      displayText,
      onConfirm,
      onCancel,
      handleClick,
    };
  },
};
</script>

<style>
/* 添加一些样式以适应你的需求 */
</style>
